import {
  EditRounded,
  ForwardToInboxRounded,
  KeyboardReturnRounded,
  LocalPrintshopRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useState } from "react";
import { Dialog, Snackbar } from "../../layout";
import ViewProd from "./ViewProd";
import { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "../../App";
import { formatDate, IsEmptyObj, PrintDiv } from "../../hooks/Method";
import { useTranslation } from "react-i18next";
import { action, controller, Server } from "../../api/Server";
import DynamicTable from "../../layout/DynamicTable/DynamicTable";
import { useNavigate } from "react-router-dom";
import GeneralPrinterReceipt from "../pos/printReceipt/GeneralPrinterReceipt";

const SalesHistory = () => {
  const { t } = useTranslation();
  const { setLoader, loader, settings, setPageTitle, authUser } =
    useContext(AppContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [printData, setPrintData] = useState({});
  const [sells, setSells] = useState([]);
  const [viewData, setViewData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [tblData, setTblData] = useState([]);
  const [access, setAccess] = useState({});
  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "success",
    msg: "",
  });

  useEffect(() => {
    setPageTitle(t("salesHistory"));
    if (authUser && authUser.featuresAccess && authUser.featuresAccess.sells)
      setAccess({ ...authUser.featuresAccess.sells });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleViewCustomer = (id) => {
    id && navigate(`/view-customer/${id}`);
  };

  useEffect(() => {
    sells &&
      setTblData([
        ...sells.map((s) => {
          return {
            ...s,
            sellDate: formatDate(s.sellDate),
            type: (
              <div className="fw-5 d-flex g-5">
                <div className="fw-5">
                  {s.status === "Due" ? (
                    <span className="bg-errorSM error-color pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
                      {t("due")}
                    </span>
                  ) : (
                    <span className="bg-successXS success-color pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
                      {t("paid")}
                    </span>
                  )}
                </div>
                {s.lastUpdateDate && (
                  <span className="bg-warningSM warning-color pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
                    {t("edited")}
                  </span>
                )}

                {s.payableRefund > 0 && (
                  <span className="bg-graySM gray-color fw-5 pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
                    {t("returned")} ({settings.curSymbol}{" "}
                    {(s.payableRefund || 0).toFixed(settings.decimal)} )
                  </span>
                )}
              </div>
            ),
            netPayable:
              settings.curSymbol +
              " " +
              (s.totalPay || 0).toFixed(settings.decimal),
            received:
              settings.curSymbol + " " + s.received.toFixed(settings.decimal),
            change:
              settings.curSymbol + " " + s.change.toFixed(settings.decimal),
            customer: (
              <span
                className={`link ${s.customerId ? "tx-und" : ""}`}
                onClick={() => handleViewCustomer(s.customerId)}
              >
                {s.customer}
              </span>
            ),
          };
        }),
      ]);

    return () => {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sells]);

  const handleEmailReceipt = (invoiceId) => {
    setLoader(true);
    Server(controller.Sell + action.EmailInvoice).getById(invoiceId, (res) => {
      setLoader(false);
      if (res && res.status === 200)
        setSnackbar({
          show: true,
          type: "success",
          msg: "You have successfully sent email the invoice.",
        });
      else
        setSnackbar({
          show: true,
          type: "error",
          msg: res.msg,
        });
    });
  };

  const handleView = (data) => {
    setViewData(data);
    setShowForm(!showForm);
  };

  const handlePrint = (id) => {
    if (id) {
      setLoading(true);
      const onComplete = (res) => {
        if (res.status === 200 && res.result !== null) {
          setPrintData({ ...res.result });
          setTimeout(() => {
            PrintDiv("printSellRecept");
          }, 1000);
        } else console.log("Print Error: ", res);
        setLoading(false);
      };

      Server(controller.Sell + action.GetById).getById(id, onComplete);
    }
  };

  const handleEdit = (id) => {
    localStorage.setItem("sellId", id);
    navigate("/pos");
  };

  const handleReturn = (id) => {
    navigate(`/sell_return/${id}`);
  };

  const ActionComp = (props) => (
    <Box className="d-flex g-5">
      {access.isHaveViewAccess && (
        <>
          <Tooltip arrow title={t("returnSale")}>
            <IconButton
              onClick={() => handleReturn(props.id)}
              size="small"
              className="mr-5"
              color="primary"
            >
              <KeyboardReturnRounded className="fs-18 m-2" />
            </IconButton>
          </Tooltip>

          <Tooltip arrow title={t("view")}>
            <IconButton
              onClick={() => handleView(props)}
              size="small"
              className="mr-5"
              color="primary"
            >
              <VisibilityRounded className="fs-18 m-2" />
            </IconButton>
          </Tooltip>

          {props.enableEdit &&
            settings.enableSaleEdit &&
            props.sellType === 1 && (
              <Tooltip arrow title={t("edit")}>
                <IconButton
                  onClick={() => handleEdit(props.id)}
                  size="small"
                  className="mr-5"
                  color="primary"
                >
                  <EditRounded className="fs-18 m-2" />
                </IconButton>
              </Tooltip>
            )}

          <IconButton
            onClick={() => handleEmailReceipt(props.id)}
            size="small"
            className="mr-5"
            color="primary"
            disabled={loader}
          >
            <ForwardToInboxRounded className="fs-18 m-2" />
          </IconButton>

          <IconButton
            onClick={() => handlePrint(props.id)}
            size="small"
            className="mr-5"
            color="primary"
            disabled={loading}
          >
            <LocalPrintshopRounded className="fs-18 m-2" />
          </IconButton>
        </>
      )}
    </Box>
  );

  const HeaderComp = () => (
    <div>
      <span className="border-left ml-5 fs-20 gray-color fw-5 tx-upp">
        {t("salesHistory")}
      </span>
    </div>
  );

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setSells}
        endpointKey={controller.Sell + action.GetAllByStore}
        exportEndpoint={controller.Sell + action.ExportSells}
        enableDateRange={true}
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        enableExport={access.isHaveExportAccess}
        headers={[
          { id: "actions", label: t("actions") },
          { id: "type", label: t("sellType") },
          { id: "sellDate", label: t("transectionDate") },
          { id: "updated", label: t("updated") },
          { id: "id", label: t("invoice") },
          { id: "totalItem", label: t("totalItem") },
          { id: "payMethods", label: t("method") },
          { id: "netPayable", label: t("netPayable") },
          { id: "received", label: t("paymentReceived") },
          { id: "change", label: t("change") },
          { id: "customer", label: t("customer") },
          { id: "cashier", label: t("cashier") },
        ]}
      />

      {printData && printData.id && (
        <Box className="d-none" id="printSellRecept">
          <GeneralPrinterReceipt data={printData} />
        </Box>
      )}

      {/* Edit Dialog */}
      <Dialog show={showForm} maxWidth="lg" onClose={false}>
        {!IsEmptyObj(viewData) && (
          <ViewProd {...{ setShowForm, id: viewData.id, viewData }} />
        )}
      </Dialog>
      <Snackbar {...{ snackbar, setSnackbar }} />
    </>
  );
};

export default SalesHistory;
